import { render, staticRenderFns } from "./caijixiangqingLessNew.vue?vue&type=template&id=70fbdccf&scoped=true"
import script from "./caijixiangqingLessNew.vue?vue&type=script&lang=js"
export * from "./caijixiangqingLessNew.vue?vue&type=script&lang=js"
import style0 from "./caijixiangqingLessNew.vue?vue&type=style&index=0&id=70fbdccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbdccf",
  null
  
)

export default component.exports